


import Vue from 'vue';
import 'jquery-match-height';
import ItemsListComponent from '@/components/items/list/items-list.vue';
import {Location} from "vue-router";
import {RouteName} from "@/router";
import i18n, {localizedRoute} from "@/i18n/i18n.config";
import {OfferItem} from "@/components/model/offer-item";
import {archive} from "@/components/archive/archive.service";
import $ from "jquery";
import {pageTitle} from "@/components/common/pageTitle";

interface Data {
    currentPage: number
    isLoading: boolean
    items: OfferItem[]
    hasNext: boolean
    hasPrev: boolean
    totalPages: number
    i18n: typeof i18n
}

export default Vue.extend({
    data(): Data {
        return {
            currentPage: 0,
            isLoading: false,
            items: [],
            hasNext: false,
            hasPrev: false,
            totalPages: 0,
            i18n,
        };
    },
    created(): void {
        this.currentPage = this.parsePageParam();
        this.setPageTitle();
        this.loadPage();
    },
    beforeRouteEnter(to, from, next) {
        pageTitle.setTitle(i18n.locale === 'pl' ? 'Archiwum' : 'Archive');
        next();
    },
    watch: {
        $route() {
            this.currentPage = this.parsePageParam();
            this.setPageTitle();
            this.loadPage();
        },
        'i18n.locale'() {
            this.setPageTitle();
        }
    },
    computed: {
        nextPageRoute(): Location {
            return {name: RouteName.archiveList, query: {p: '' + (this.currentPage + 1)}};
        },
        prevPageRoute(): Location {
            if (this.currentPage === 1) {
                return {name: RouteName.archiveList};
            } else {
                return {name: RouteName.archiveList, query: {p: '' + (this.currentPage - 1)}};
            }
        },
        detailsRouteName(): RouteName {
            return RouteName.archiveDetails;
        },
        offerRoute(): Location {
            return localizedRoute(RouteName.offerList);
        }
    },
    methods: {
        parsePageParam(): number {
            if (this.$route.query.p) {
                const currentPage = parseInt(this.$route.query.p as string);
                if (isNaN(currentPage)) {
                    this.$router.replace({name: RouteName.notFound});
                    return 0;
                } else {
                    return currentPage;
                }
            } else {
                return 0;
            }
        },
        loadPage() {
            if (this.isLoading) {
                return;
            }
            $('html, body').animate({
                scrollTop: 0
            }, 700);
            this.isLoading = true;
            archive.loadPage(this.currentPage)
                .then(page => {
                    if (page.content.length === 0) {
                        this.$router.replace({name: RouteName.notFound});
                        return;
                    }
                    this.items = page.content;
                    this.hasNext = !page.last;
                    this.hasPrev = !page.first;
                    this.totalPages = page.totalPages;
                })
                .finally(() => this.isLoading = false);
        },
        setPageTitle() {
            if (this.currentPage === 0) {
                pageTitle.setTitle(this.$t('archive.title'));
            } else {
                pageTitle.setTitle(this.$t('archive.pagedTitle', {pageNumber: this.currentPage + 1}));
            }
        }
    },
    metaInfo() {
        return {
            link: [
                {vmid: 'canonical', rel: 'canonical', href: location.origin + this.$route.fullPath}
            ]
        }
    },
    components: {
        'items-list': ItemsListComponent
    }
});
